<script>
  import Vue from 'vue';


  export default Vue.extend({
    props: ['value', 'name', 'checked', 'disabled'],
    model: {
      prop : 'checked',
      event: 'change',
    },
    methods: {
      onChange(){
        this.$emit('change', this.value);
      }
    }
  });
</script>

<template>
  <div class="radio">
    <label>
      <input type="radio" :disabled="disabled" :checked="checked==value" :name="name" :value="value" @change="onChange">
      <i></i><span><slot></slot></span>
    </label>
  </div>
</template>



// WEBPACK FOOTER //
// Radio.vue?022c6b72